import React, { FunctionComponent } from "react"
import { createMuiTheme, Theme, ThemeProvider } from "@material-ui/core/styles"
import { useAuth } from "../common/hooks/useAuth"
import { Title } from "./Title"
import { BrandFavicon } from "./BrandFavicon"

export const BrandThemeProvider: FunctionComponent = ({ children }) => {
    const { branding } = useAuth()

    return (
        <ThemeProvider
            theme={(theme: Theme) =>
                createMuiTheme({
                    ...theme,
                    overrides: {
                        MuiButton: {
                            root: {
                                "&:hover": {
                                    backgroundColor:
                                        (branding?.colors?.primary ?? theme.palette.primary.main) +
                                        " !important"
                                }
                            }
                        }
                    },
                    palette: {
                        ...theme.palette,
                        primary: {
                            ...theme.palette.primary,
                            main: branding?.colors?.primary ?? theme.palette.primary.main
                        },
                        secondary: {
                            ...theme.palette.secondary,
                            main: branding?.colors?.secondary ?? theme.palette.secondary.main
                        }
                    }
                })
            }
        >
            <BrandFavicon />
            <Title />
            {children}
        </ThemeProvider>
    )
}
